/**
 * Parse CSV text into a grid of cells (one inner array per row).
 *
 * Handles quoted fields with embedded commas and `""`-escaped quotes.
 * Multi-line quoted fields are not supported — a newline always starts a new
 * row. CRLF (Windows) and lone CR (old Mac) line endings are normalized to LF
 * before splitting.
 *
 * Kept separate from rendering so the parsing rules can be unit-tested
 * without a DOM.
 */
export function parseCsv(code: string): string[][] {
  return code
    .replace(/\r\n|\r/g, "\n")
    .split("\n")
    .map(parseCsvRow);
}

function parseCsvRow(row: string): string[] {
  const cells: string[] = [];
  let current = "";
  let inQuotes = false;

  for (let i = 0; i < row.length; i++) {
    const c = row[i];

    if (inQuotes) {
      if (c === '"' && row[i + 1] === '"') {
        // Escaped quote inside a quoted field.
        current += '"';
        i++;
      } else if (c === '"') {
        inQuotes = false;
      } else {
        current += c;
      }
      continue;
    }

    if (c === '"' && current === "") {
      inQuotes = true;
    } else if (c === ",") {
      cells.push(current);
      current = "";
    } else {
      current += c;
    }
  }

  cells.push(current);
  return cells;
}
